import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdminUsuario } from '../models/admin-usuario';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminUsuarioService extends AbstractService<AdminUsuario> {

  titulo: string = 'Usuário';
  endpoint(): string {
    return "usuario";
  }
  rotina(): string {
    return "USUARIO";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Login", field: "login" },
      { header: "Nome", field: "nome" },
    ];
  }
  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/usuarios/cadastro']);
  }
  abrir(obj: AdminUsuario) {
    AbstractService.readonly = true;
    this.router.navigate(['adm/usuarios/cadastro'], { queryParams: { id: obj.id } });
  }
  edit(obj: AdminUsuario) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/usuarios/cadastro'], { queryParams: { id: obj.id } });
  }
  routeLista() {
    return '/adm/usuarios';
  }

  getTokenUtils(): Observable<any> {
    const url = this.baseUrl() + "/gera-token-utils";
    const params = new URLSearchParams();

    const h = new HttpHeaders({
      Accept: "*/*; charset=utf-8",
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Auth-Token": AbstractService.token(),
    });
    return this.http.post(url, params.toString(), { headers: h, responseType: 'text' as 'text' });
  }

  constructor(
    http: HttpClient,
    private router: Router,
    loginService: LoginService
  ) {
    super(http, loginService);
  }
}
